import React, {useState, useEffect, useMemo} from 'react';
import LoginForm from './LoginForm.js';

import {callback, usePrevious} from '../helpers.js';
import api from '../api/index.js';


export default (props) => {
	const [isLoggedIn, setIsLoggedIn] = useState(false);

	const loggedIn = (data) => {
		console.log("Logged in data", data);
		setIsLoggedIn(api.auth.isLoggedIn());
	}
	
	const loggedOut = () => {
		setIsLoggedIn(false);
	}


	const tryLogin = async () => {
		try {
			const result = await api.auth.isLoggedIn();
			setIsLoggedIn(result);
		} catch(e) {
			setIsLoggedIn(false);
		}
	};

	useEffect(() => {
		api.addEventListener('Auth.userRetrieved', loggedIn);
		api.addEventListener('Auth.loggedIn', loggedIn);
		api.addEventListener('Auth.loggedOut', loggedOut);

		tryLogin();

		return ()=>{
			api.removeEventListener('Auth.userRetrieved', loggedIn);
			api.removeEventListener('Auth.loggedOut', loggedOut);
			api.removeEventListener('Auth.loggedIn', loggedIn);
		}
	});

	if (isLoggedIn)
		return <>{props.children}</>;
	return <div className="login-page"><LoginForm /></div>;

}